import SystemEnum from '@/assets/js/systemEnum'
import DataType from '@/util/dataType'
const WORK_QUEUE = SystemEnum.WORK_QUEUE_ENUM
const BANKRUPTCY_QUEUE = [
  {
    status: WORK_QUEUE.PENDING_BANKRUPTCY.value,
    title: WORK_QUEUE.PENDING_BANKRUPTCY.text,
    key: WORK_QUEUE.PENDING_BANKRUPTCY.key,
    features: WORK_QUEUE.PENDING_BANKRUPTCY.features,
    code: DataType.PrivilegeCode.PENDING_BANKRUPTCY,
    color: ['#5BCDF2', '#F2FBFE'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  },
  {
    status: WORK_QUEUE.BANKRUPTCY.value,
    title: WORK_QUEUE.BANKRUPTCY.text,
    key: WORK_QUEUE.BANKRUPTCY.key,
    features: WORK_QUEUE.BANKRUPTCY.features,
    code: DataType.PrivilegeCode.BANKRUPTCY,
    color: ['#FF843F', '#FFF7F2'],
    count: 0,
    items: [],
    indexOfPage: 1,
    isEnd: true,
    isLoading: true
  }
]
export default BANKRUPTCY_QUEUE
